import {
  useGetScimPersonalAccessTokensQuery,
  ScimPersonalAccessTokenFragment,
} from '@sketch/gql-types'

export const useGetScimPersonalAccessTokens = () => {
  const { data, loading, error } = useGetScimPersonalAccessTokensQuery({
    fetchPolicy: 'cache-and-network',
  })

  const personalTokens: ScimPersonalAccessTokenFragment[] =
    data?.me?.scimPersonalAccessTokens || []

  return {
    personalTokens,
    loading,
    error,
  }
}
